// ============================================================
// xFreeScan - Corporate Email Validation (Frontend)
// Blocks free/personal email domains. Only corporate emails allowed.
// ============================================================

const FREE_EMAIL_DOMAINS: ReadonlySet<string> = new Set([
  // Google
  'gmail.com', 'googlemail.com',
  // Microsoft
  'hotmail.com', 'hotmail.es', 'hotmail.co.uk', 'hotmail.fr', 'hotmail.de', 'hotmail.it',
  'outlook.com', 'outlook.es', 'outlook.co.uk', 'outlook.fr', 'outlook.de',
  'live.com', 'live.es', 'live.co.uk', 'live.fr', 'live.de',
  'msn.com',
  // Yahoo
  'yahoo.com', 'yahoo.es', 'yahoo.co.uk', 'yahoo.fr', 'yahoo.de', 'yahoo.it',
  'yahoo.com.mx', 'yahoo.com.ar', 'yahoo.com.br', 'yahoo.com.co',
  'ymail.com', 'rocketmail.com',
  // Apple
  'icloud.com', 'me.com', 'mac.com',
  // AOL
  'aol.com', 'aol.co.uk',
  // Zoho (free tier)
  'zohomail.com',
  // ProtonMail
  'protonmail.com', 'protonmail.ch', 'proton.me', 'pm.me',
  // Tutanota
  'tutanota.com', 'tutanota.de', 'tutamail.com', 'tuta.io',
  // GMX
  'gmx.com', 'gmx.net', 'gmx.de', 'gmx.at', 'gmx.ch', 'gmx.es',
  // Mail.com
  'mail.com', 'email.com', 'usa.com', 'consultant.com', 'post.com',
  // Yandex
  'yandex.com', 'yandex.ru', 'ya.ru',
  // Mail.ru
  'mail.ru', 'inbox.ru', 'bk.ru', 'list.ru',
  // Latin America popular
  'terra.com', 'terra.com.mx', 'terra.com.br', 'terra.es',
  'latinmail.com', 'starmedia.com',
  // Misc
  'mailfence.com', 'disroot.org', 'riseup.net', 'autistici.org',
  'cock.li', 'airmail.cc',
  'fastmail.com', 'fastmail.fm',
  'hushmail.com',
  'mailbox.org',
  'runbox.com',
  'startmail.com',
  'guerrillamail.com', 'guerrillamail.de', 'grr.la', 'guerrillamailblock.com',
  'tempmail.com', 'temp-mail.org', 'throwaway.email',
  'sharklasers.com', 'guerrillamail.info', 'spam4.me',
  'trashmail.com', 'trashmail.net', 'trashmail.me',
  'mailinator.com', 'maildrop.cc', 'dispostable.com', 'yopmail.com', 'yopmail.fr',
  'getnada.com', 'tempail.com', 'mohmal.com',
  '10minutemail.com', 'minutemail.com',
  'mailnesia.com', 'mailtothis.com',
]);

/**
 * Check if an email uses a free/personal domain.
 * Returns true if the email is from a FREE provider (i.e. NOT corporate).
 */
export function isFreeEmailDomain(email: string): boolean {
  const parts = email.toLowerCase().trim().split('@');
  if (parts.length !== 2 || !parts[1]) return true;
  return FREE_EMAIL_DOMAINS.has(parts[1]);
}

/**
 * Validate that an email is corporate.
 * Returns an error message if invalid, or null if valid.
 */
export function validateCorporateEmail(email: string): string | null {
  if (!email || !email.includes('@')) {
    return 'Formato de email invalido';
  }
  if (isFreeEmailDomain(email)) {
    return 'Solo se permiten correos corporativos. No se aceptan correos gratuitos como Gmail, Hotmail, Yahoo, etc. Use su correo de empresa (ej: nombre@suempresa.com).';
  }
  return null;
}

/** Error message constant for UI display */
export const CORPORATE_EMAIL_ERROR =
  'Solo se permiten correos corporativos. No se aceptan correos gratuitos como Gmail, Hotmail, Yahoo, etc.';
